import { ApiService } from './ApiService';
import { Section, SidebarNode } from '../store/storeSidebarTree';

export type BackendNodeKind = 'folder' | 'flow' | 'form' | 'object' | 'vector';

export interface MoveNodeRequest {
  nodeId: string;
  nodeKind: BackendNodeKind;
  parentId: string | null;
  rank: string;
  section?: Section;
  spaceId?: string | null;
}

export interface MoveNodeResponse {
  node: SidebarNode;
}

export interface RebalanceRequest {
  parentId: string | null;
  section: Section;
  spaceId: string | null;
}

export interface RebalanceResponse {
  nodes: SidebarNode[];
}

export class SidebarMoveService {
  static async moveNode(req: MoveNodeRequest): Promise<MoveNodeResponse> {
    const res = await ApiService.post('/folder/move-node', req);
    return res.data as MoveNodeResponse;
  }

  static async rebalanceSiblings(
    req: RebalanceRequest,
  ): Promise<RebalanceResponse> {
    const res = await ApiService.post('/folder/rebalance-siblings', req);
    return res.data as RebalanceResponse;
  }
}
